const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const moment = require("moment");
const _ = require("lodash");
const withVaultDispatch = require("src/core/hoc/withVaultDispatch");
const withVaultUpdate = require("src/core/hoc/withVaultUpdate");
const AT = require("src/core/vault/ActionTypes");
const Link = require("src/core/view/Link");
const SubscriptionUtil = require("shared/SubscriptionUtil");
const URLMake = require("shared/URLMake");
const ToggleItem = require("src/office/ToggleItem");
const DeleteIcon = require("src/office/DeleteIcon");
const AddElement = require("src/office/AddElement");
const ButtonWithConfirm = require("src/office/ButtonWithConfirm");
const SelectModal = require("src/office/modals/SelectOptionModal");
const OfficeModal = require("src/office/modals/OfficeModal");
const Dropdown = require("src/core/view/DropdownSelect");
const LoadableButton = require("src/office/LoadableButton");
const CancelOtherSubscriptionModal = require("src/office/modals/CancelOtherSubscriptionModal");
const CancelBundleModal = require("src/office/modals/CancelBundleModal");
const Input = require("src/office/checkout/Input");
const Avatar = require("src/core/view/Avatar");
const CopyTable = require("src/office/data/CopyTable");
const Editable = require("src/office/Editable");
const EditableField = require("./EditableField");
const StringUtil = require("shared/StringUtil");
const InfoIcon = require("src/office/InfoIcon");
const {Gift, BookText} = require("lucide-react");
const styles = require("./styles/SubscriptionRow.css");
const {getStudentRegistrationPage} = require("src/core/vault/OpsPage");
const {onClickLoginAsStudent} = require("src/parent/util/ParentUtil");
const {BUNDLE_GRADE_PREFIX} = require("shared/StoreSkuUtil");
const BookstoreUtil = require("shared/BookstoreUtil");
const {getBundleGrade} = require("shared/StoreBundleUtil");
const {
	getPlacementLevelAndChapter,
} = require("src/core/home/util/PageOnboardingUtil");

const GRADE_LIST = BookstoreUtil.getAvailableGradeNumbers();

const getProvisionalDeferralGrade = function(deferral) {
	const provisionalGrade = deferral
		? getBundleGrade(deferral.provisionalBundleID)
		: null;
	return provisionalGrade || GRADE_LIST[0] || 1;
};

const getPlacementGradeFromResults = function(placementTestInfo, user) {
	if (
		!placementTestInfo?.previousResults?.results ||
		!placementTestInfo.previousResults.results.length
	) {
		return null;
	}
	const {level} = getPlacementLevelAndChapter(placementTestInfo, user);
	const grade = parseInt(level, 10);
	return _.includes(GRADE_LIST, grade) ? grade : null;
};

const getPlacementLabelFromResults = function(placementTestInfo, user) {
	const grade = getPlacementGradeFromResults(placementTestInfo, user);
	if (grade == null) {
		return null;
	}
	const previousResult = placementTestInfo.previousResults.results[0].placement;
	if (parseInt(previousResult[0], 10) > 5) {
		return `Level ${grade}D`;
	}
	return `Level ${previousResult[0]}${previousResult[1]}`;
};

// Bundles can renew before this, but make it more obvious at this time.
const BUNDLE_RENEW_DAYS = 50;

// Make subscription expiration red 30 days before expiration
const EXPIRATION_WARNING_DAYS = 30;

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "AccountSubscriptionRow",

		propTypes: {
			payments: PT.object,
			students: PT.array, //all students
			className: PT.string,
			data: PT.object.isRequired, //individual student data
			startPasswordChange: PT.bool, //If password change should start immediately after mount
			renewPrice: PT.string,
			ownerCanPay: PT.bool,
			ownerCanReactivate: PT.bool,
			isPurchaseOrder: PT.bool,
			user: PT.object.isRequired,
			deferral: PT.object, // pending book-level deferral for this student, if any

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		vaultEvents: {
			bookDeferralResolved: function(result) {
				const rowSubscriptionID = String(
					this.props.data.subscription.subscriptionID
				);
				const resolvedSubscriptionID = String(
					_.get(result, ["deferral", "subscriptionID"])
				);
				if (rowSubscriptionID !== resolvedSubscriptionID) return;
				this.setState({deferralStatus: "success"});
			},
			bookDeferralResolveFail: function(deferralID) {
				const {deferral} = this.props;
				if (!deferral || deferralID !== deferral.id) return;
				this.setState({deferralStatus: "error"});
			},
			deferralPlacementLoaded: function(studentID, placementTestInfo) {
				if (studentID !== this.props.data.userID) return;
				const placementLabel = getPlacementLabelFromResults(
					placementTestInfo,
					this.props.user
				);
				this.setState({
					deferralPlacementLoaded: true,
					deferralPlacementLabel: placementLabel,
				});
			},
			deferralPlacementLoadFailed: function(studentID) {
				if (studentID !== this.props.data.userID) return;
				this.setState({deferralPlacementLoaded: true});
			},
			imitateStudentFail: function(studentID) {
				if (studentID !== this.props.data.userID) return;
				this.setState({deferralPlacementTestStatus: null});
			},
			// Change student settings
			parentStudentInfoPending: function() {
				this.setState({studentInfoStatus: "pending"});
			},
			parentStudentInfoSuccess: function() {
				this.setState({studentInfoStatus: ""});
				this.closeModals();
			},
			parentStudentInfoFail: function(error) {
				this.setState({studentInfoStatus: error});
			},
			parentSubscriptionInfoPending: function() {
				// Do nothing
			},
			parentSubscriptionInfoSuccess: function() {
				// Do nothing
			},
			parentSubscriptionInfoFail: function(error, moreInfo, data) {
				const studentKey = _.get(data, "0.0.1");
				const key = _.findIndex(
					this.props.students,
					s => s.userID === this.props.data.userID
				);
				if (studentKey === key) {
					this.setState({error});
				}
			},
			// Cancel subscription
			// Failure cases are handled elsewhere.
			cancelSubscriptionSuccess: function() {
				this.setState({cancelStatus: "success"});
			},
			// Couldn't cancel subscription because another
			// must be canceled first.
			cancelOtherSubscription: function() {
				this.setState({cancelStatus: null});
			},
			additionalEmailSignUpStarted: function() {
				this.setState({additionalEmailsStatus: "pending"});
			},
			additionalEmailSignUpComplete: function(status) {
				if (status === "success") {
					this.closeModals();
				} else {
					this.setState({additionalEmailsStatus: status});
				}
			},
		},

		getInitialState: function() {
			if (this.props.startPasswordChange) {
				const {userID, displayName} = this.props.data;
				this.dispatchChangePassword(displayName, userID);
			}
			const {deferral} = this.props;
			return {
				selectType: null, // select modal open if not null
				error: null,
				studentInfoStatus: null,
				cancelStatus: null,
				additionalEmailsStatus: null,
				additionalEmails: this.props.data.additionalEmails,
				newAdditionalEmails: null,
				cancelOtherSubscriptionOpen: false,
				cancelBundleOpen: false,
				// Book deferral
				deferralGrade: getProvisionalDeferralGrade(deferral),
				deferralPlacementLabel: null,
				deferralPlacementLoaded: false,
				deferralPlacementTestStatus: null, // null | "pending"
				deferralStatus: null, // null | "pending" | "success" | "error"
			};
		},

		componentDidMount: function() {
			this.loadDeferralPlacementGrade();
		},

		componentDidUpdate: function(prevProps) {
			const prevDeferral = prevProps.deferral;
			const nextDeferral = this.props.deferral;
			if (!prevDeferral && nextDeferral) {
				this.setState({
					deferralGrade: getProvisionalDeferralGrade(nextDeferral),
					deferralPlacementLabel: null,
					deferralPlacementLoaded: false,
					deferralPlacementTestStatus: null,
				});
				this.loadDeferralPlacementGrade();
			}
		},

		loadDeferralPlacementGrade: function() {
			const {deferral, data} = this.props;
			if (!deferral || !data.platformUserID) return;
			this.props.dispatch({
				type: AT.LOAD_DEFERRAL_PLACEMENT_REQUEST,
				studentID: data.userID,
				platformUserID: data.platformUserID,
			});
		},

		openSelect: function(type) {
			const newState = {
				selectType: type,
				error: null,
				studentInfoStatus: null,
				cancelStatus: null,
				additionalEmailsStatus: null,
				cancelOtherSubscriptionOpen: false,
				cancelBundleOpen: false,
			};
			if (type === "updatesSettings") {
				newState.newAdditionalEmails = _.map(
					this.state.additionalEmails,
					email => {
						return {email, error: null};
					}
				);
			}
			this.setState(newState);
		},

		openCancelOtherModal: function() {
			this.setState({
				selectType: null,
				error: null,
				studentInfoStatus: null,
				cancelStatus: null,
				additionalEmailsStatus: null,
				cancelOtherSubscriptionOpen: true,
				cancelBundleOpen: false,
			});
		},

		openCancelBundleModal: function() {
			this.setState({
				selectType: null,
				error: null,
				studentInfoStatus: null,
				cancelStatus: null,
				additionalEmailsStatus: null,
				cancelOtherSubscriptionOpen: false,
				cancelBundleOpen: true,
			});
		},

		selectOption: function(type, selectState) {
			const option = selectState.selected;
			const checked = selectState.checkboxesChecked || [];
			const dispatchObj = {
				type: AT.SAVE_PARENT_STUDENT_INFO_REQUEST,
				studentID: this.props.data.userID,
			};
			if (type === "lockSettings") {
				dispatchObj.lockSettings = {
					scheme: option,
					test: _.includes(checked, "test"),
					lab: _.includes(checked, "lab"),
				};
			} else {
				dispatchObj[type] = option;
			}
			this.props.dispatch(dispatchObj);
		},

		updateDisplayName: function(name) {
			this.props.dispatch({
				type: AT.SAVE_PARENT_STUDENT_INFO_REQUEST,
				studentID: this.props.data.userID,
				displayName: name,
			});
		},

		getLocking: function(lockType) {
			return <div className={styles.lockType}>{lockType}</div>;
		},

		goToSubscribeFlow: function(type) {
			if (type === "reactivate" && !this.props.ownerCanReactivate) {
				this.props.dispatch({
					type: AT.SHOW_OFFICE_MESSAGE,
					messageType: "ownerReactivateHitLimit",
				});
			} else {
				this.props.dispatch({
					type: AT.SET_PAGE,
					pageState: URLMake.state.forAccountSubscribe(
						type,
						this.props.data.userID
					),
					addToHistory: true,
				});
			}
		},

		cancelSubscription: function(studentID) {
			this.setState({cancelStatus: "pending"});
			this.props.dispatch({
				type: AT.FINISH_SUBSCRIPTION_CANCEL_REQUEST,
				studentID,
			});
		},

		getButton: function(subscription) {
			let button = null;
			if (subscription.active) {
				if (subscription.planType === "bundle") {
					const expDate = subscription.expiresAt;
					const daysBefore = moment.duration(BUNDLE_RENEW_DAYS, "d");
					const highlightRenew = moment().isAfter(
						moment(expDate).subtract(daysBefore)
					);
					const buttonClass = highlightRenew ? styles.buttonRed : styles.button;
					button = (
						<div
							className={buttonClass}
							onClick={this.withOwnerCanPayCheck(() =>
								this.goToSubscribeFlow("renew")
							)}
						>
							Renew Bundle
						</div>
					);
				}
			} else if (!this.props.data.inActiveClasses) {
				// We want to not show this button if the student is in a
				// class. Don't allow parent to activate subscription. This is
				// different from ownerCanReactivate check which uses
				// OpsParentAcc.canActivateStudent which only checks for max
				// subscriptions and warns parent.
				const className = styles.button;
				button = (
					<div
						className={className}
						onClick={this.withOwnerCanPayCheck(() =>
							this.goToSubscribeFlow("reactivate")
						)}
					>
						Activate
					</div>
				);
			}
			return button;
		},

		closeModals: function(extraInfo) {
			this.setState(
				_.extend(
					{
						selectType: null,
						studentInfoStatus: null,
						newAdditionalEmails: null,
						additionalEmailsStatus: null,
						cancelOtherSubscriptionOpen: false,
						cancelBundleOpen: false,
					},
					extraInfo
				)
			);
		},

		onDeferralGradeChange: function(gradeKey) {
			this.setState({deferralGrade: parseInt(gradeKey, 10)});
		},

		onDeferralPlacementTestClick: function(e) {
			e.preventDefault();
			if (this.state.deferralPlacementTestStatus === "pending") {
				return;
			}
			this.setState({deferralPlacementTestStatus: "pending"});
			this.debouncedDeferralPlacementTestClick =
				this.debouncedDeferralPlacementTestClick ||
				_.debounce(
					() => {
						const {data} = this.props;
						onClickLoginAsStudent(
							this.props.dispatch,
							{
								id: data.userID,
								displayName: data.displayName,
								username: data.username,
								avatarData: data.avatar || {},
								hasRegistered: true,
							},
							"from-account-deferral"
						);
					},
					500,
					{leading: true, trailing: false}
				);
			this.debouncedDeferralPlacementTestClick();
		},

		onDeferralConfirm: function() {
			const {deferral} = this.props;
			const {subscription} = this.props.data;
			if (
				!deferral ||
				subscription.booksCanceled ||
				this.state.deferralStatus === "pending"
			) {
				return;
			}
			const bundleID = `${BUNDLE_GRADE_PREFIX}${this.state.deferralGrade}`;
			this.setState({deferralStatus: "pending"});
			this.props.dispatch({
				type: AT.RESOLVE_BOOK_DEFERRAL_REQUEST,
				deferralID: deferral.id,
				bundleID,
			});
		},

		closeDeferralSuccessModal: function() {
			this.setState({deferralStatus: null});
		},

		onSaveEmails: function() {
			if (_.some(this.state.newAdditionalEmails, obj => obj.error)) {
				return;
			}
			const emails = _.compact(
				_.map(this.state.newAdditionalEmails, obj => obj.email)
			);
			const addEmails = _.difference(emails, this.state.additionalEmails);
			const removeEmails = _.difference(this.state.additionalEmails, emails);
			this.props.dispatch({
				type: AT.SIGN_UP_ADDITIONAL_EMAIL_RECIPIENTS_REQUEST,
				studentID: this.props.data.userID,
				userID: this.props.user.userID,
				addEmails,
				removeEmails,
			});
			this.setState({additionalEmails: emails});
		},

		handleKeyPress: function(evt, type) {
			if (evt.which === 13) {
				if (type === "saveChanges") {
					this.onSaveEmails();
				} else {
					this.closeModals();
				}
			}
		},

		dispatchChangePassword: function(displayName, studentID) {
			this.props.dispatch({
				type: AT.START_CHANGE_PASSWORD,
				opts: {
					displayName,
					studentID,
					forAccountPage: true,
				},
			});
		},

		changePassword: function(displayName, studentID) {
			this.dispatchChangePassword(displayName, studentID);
			this.reset();
		},

		// Wraps a function with a check that the owner can pay &
		// shows a message if they cannot
		withOwnerCanPayCheck: function(f) {
			return (...args) => {
				if (!this.props.ownerCanPay) {
					this.props.dispatch({
						type: AT.SHOW_OFFICE_MESSAGE,
						messageType: "noOwnerPayment",
					});
				} else {
					f(...args);
				}
			};
		},

		withOwnerCanSwitchCheck: function(student, f) {
			return (...args) => {
				const subscription = _.get(student, "subscription");
				const failed = _.get(subscription, "failedAttempts", 0);
				const willExpireSoon = SubscriptionUtil.isActivePastExpiration(
					subscription
				);
				if (failed && !willExpireSoon) {
					this.props.dispatch({
						type: AT.SHOW_OFFICE_MESSAGE,
						messageType: "noOwnerSwitchWhileFailed",
					});
				} else {
					return this.withOwnerCanPayCheck(f)();
				}
			};
		},

		onToggleRenew: function(isOn) {
			this.props.dispatch({
				type: AT.SAVE_PARENT_SUBSCRIPTION_REQUEST,
				studentID: this.props.data.userID,
				autoRenew: isOn,
			});
		},

		onToggleNotifications: function(isOn) {
			this.props.dispatch({
				type: AT.SAVE_PARENT_SUBSCRIPTION_REQUEST,
				studentID: this.props.data.userID,
				weeklyNotification: isOn,
			});
			this.reset();
		},

		onToggleLeaderboards: function(isOn) {
			this.props.dispatch({
				type: AT.SET_STUDENT_LEADERBOARDS_LOCK_OVERRIDE_REQUEST,
				studentID: this.props.data.userID,
				value: isOn,
			});
			this.reset();
		},

		onToggleBeastBuilder: function(isOn) {
			this.props.dispatch({
				type: AT.SET_STUDENT_BEASTBUILDER_LOCK_OVERRIDE_REQUEST,
				studentID: this.props.data.userID,
				value: isOn,
			});
		},

		reset: function() {
			this.setState({error: null});
		},

		getSettings: function(data, settingClass) {
			const {
				grade,
				subscription,
				lockSettings,
				beastLock,
				leaderboardsLock,
				username,
				avatar,
			} = data;
			const scheme = lockSettings.scheme;
			const gradeOptions = CopyTable.getAccountOptions({type: "grade"});
			const lockOptions = CopyTable.getAccountOptions({
				type: "lockSettings",
				styles,
				isParent: true,
			});
			const updateOptions = CopyTable.getAccountOptions({type: "updates"});
			const beastToggle = CopyTable.getAccountOptions({type: "beast"});
			const leaderboardsToggle = CopyTable.getAccountOptions({
				type: "leaderboards",
				username,
				avatarModel: avatar,
			});
			const qtyEmails = this.state.additionalEmails.length;
			const updatesLabel =
				qtyEmails === 0 ? (
					"Add email address(es)"
				) : (
					<div className={styles.additionalEmailEditable}>
						<div className={styles.firstAdditionalEmail}>
							{`To: ${this.state.additionalEmails[0]}`}
						</div>
						{qtyEmails > 1 ? (
							<div className={styles.qtyAdditionalEmails}>
								{`+${qtyEmails - 1}`}
							</div>
						) : null}
					</div>
				);

			if (!subscription.active) return null;
			return (
				<div className={settingClass}>
					<div className={styles.settingsRow}>
						<div className={styles.settingItem}>
							<div className={styles.settingLabel}>
								<InfoIcon
									text={gradeOptions.info}
									title={gradeOptions.infoTitle}
									isModal={true}
									className={styles.info}
								/>
								{"BA Level:"}
							</div>
							<Editable
								className={styles.settingEditable}
								onClick={() => this.openSelect("grade")}
								text={grade.toString()}
							/>
						</div>
						<div className={styles.settingItem}>
							<div className={styles.settingLabel}>
								<InfoIcon
									text={lockOptions.info}
									title={lockOptions.infoTitle}
									isModal={true}
									className={styles.info}
								/>
								{"Lock Scheme:"}
							</div>
							<Editable
								className={styles.settingEditable}
								onClick={() => this.openSelect("lockSettings")}
								text={lockOptions.opts[scheme].label}
							/>
						</div>
					</div>
					<div className={styles.settingsRow}>
						<div className={styles.settingItem}>
							<div className={styles.settingLabel}>
								<InfoIcon
									text={updateOptions.info}
									title={updateOptions.infoTitle}
									isModal={true}
									className={styles.info}
								/>
								{"Email Updates:"}
								<ToggleItem
									className={styles.toggleInLabel}
									onToggle={this.onToggleNotifications}
									isOn={subscription.weeklyNotification}
								/>
							</div>
							<Editable
								className={styles.settingEditable}
								onClick={() => this.openSelect("updatesSettings")}
								text={updatesLabel}
							/>
						</div>
						<div className={styles.settingItem}>
							<div className={styles.settingLabel}>
								<InfoIcon
									text={beastToggle.info}
									title={beastToggle.infoTitle}
									isModal={true}
									className={styles.info}
								/>
								{"Beast Builder Access:"}
							</div>
							<ToggleItem
								className={styles.toggle}
								onToggle={this.onToggleBeastBuilder}
								isOn={beastLock !== "locked"}
							/>
						</div>
					</div>
					<div className={styles.settingsRow}>
						<div className={styles.settingItem}>
							<div className={styles.settingLabel}>
								<InfoIcon
									text={leaderboardsToggle.info}
									title={leaderboardsToggle.infoTitle}
									isModal={true}
									className={styles.info}
								/>
								{"Leaderboards:"}
								<ToggleItem
									className={styles.toggleInLabel}
									onToggle={this.onToggleLeaderboards}
									isOn={leaderboardsLock !== "locked"}
								/>
							</div>
						</div>
					</div>
				</div>
			);
		},

		getCancelEl: function(student) {
			const {subscription, userID} = student;
			const {refundable, completeRefund} = subscription;
			const cancelClass = refundable ? styles.cancel : styles.cancelHidden;

			if (_.get(completeRefund, "hardType") === "primaryButOtherMultis") {
				return (
					<div className={cancelClass} onClick={this.openCancelOtherModal}>
						Cancel / Refund
					</div>
				);
			} else if (subscription.planType === "bundle") {
				return (
					<div className={cancelClass} onClick={this.openCancelBundleModal}>
						Cancel / Refund
					</div>
				);
			} else {
				const copy = CopyTable.getNonBundleCancelCopy(
					styles,
					student,
					this.props.students
				);

				return (
					<ButtonWithConfirm
						className={cancelClass}
						title={copy.title}
						buttonText={"Cancel / Refund"}
						confirmWarning={copy.message}
						failMessage={copy.fail}
						modalButtonTexts={["cancel subscription", "keep subscription"]}
						modalRedButtonIndices={[0]}
						onClick={() => this.cancelSubscription(userID)}
						status={this.state.cancelStatus}
						closeOnPending={true}
						modalClass={styles.buttonModal}
					/>
				);
			}
		},

		getExpirationEl: function(student) {
			const {subscription, latestAcademyClassEndTime} = student;
			const {planType, autoRenew, expiresAt, effectivePlanType} = subscription;
			// access is dependent on an academy class if the student is in one
			// otherwise, take the expiration date tied to the family purchased subscription
			const accessEndsAt = latestAcademyClassEndTime ?? expiresAt;
			const accessEndDate = moment(accessEndsAt).format("ll");
			const accessEndDateLong = moment(accessEndsAt).format("LL");
			const isPurchaseOrder = !!subscription.purchaseOrderID;
			const isTrial = !!subscription.isTrial;
			let expireText;
			let makeRed = false;
			if (autoRenew) {
				expireText = `Renews ${accessEndDate}`;
				// If the effective subscription type is different from the type it will be
				// upon renewal, show a message indicating the subscription will renew
				// as a different type
				if (planType !== effectivePlanType) {
					expireText = `(Renews as ${_.capitalize(planType)} ${moment(
						accessEndsAt
					).format("LL")})`;
				} else if (this.props.renewPrice) {
					expireText += ` (${StringUtil.toPrice(this.props.renewPrice)})`;
				}
			}
			// if the subscription is not auto-renewing, show the expiration date
			else {
				// special case for subscriptions from an academy class
				if (latestAcademyClassEndTime) {
					expireText = `Access will end on ${accessEndDate}`;
				}
				// normal subscription expiration
				else {
					expireText = `Expires ${accessEndDate}`;
				}
				// make the text red if the subscription is expiring soon
				const daysBefore = moment.duration(EXPIRATION_WARNING_DAYS, "d");
				makeRed = moment().isAfter(moment(accessEndsAt).subtract(daysBefore));
			}

			const cancel = this.getCancelEl(student);

			let renew = null;
			if (
				planType !== "bundle" &&
				!isPurchaseOrder &&
				!isTrial &&
				!latestAcademyClassEndTime
			) {
				renew = (
					<div className={styles.subItem}>
						<div className={styles.subLabel}>{"Auto-renew: "}</div>
						<ToggleItem
							className={styles.toggle}
							onToggle={this.withOwnerCanPayCheck(this.onToggleRenew)}
							confirmOffWarning={CopyTable.getRenewConfirmCopy(
								accessEndDateLong
							)}
							handleClick={this.reset}
							isOn={autoRenew}
						/>
					</div>
				);
			}

			return (
				<div className={styles.renew}>
					{renew}
					<div className={makeRed ? styles.warningText : styles.text}>
						{expireText}
					</div>
					{cancel}
				</div>
			);
		},

		getSubscriptionDetails: function(student) {
			const {subscription} = student;
			const {
				active,
				planType,
				usedB2BBulkCode,
				effectivePlanType,
			} = subscription;
			const isPurchaseOrder = !!subscription.purchaseOrderID;
			const isTrial = !!subscription.isTrial;
			let subDetails;
			if (active) {
				let switchButton;
				let switchWarning;
				const {canUpgrade, upgradeUntil} = SubscriptionUtil.getUpgradeInfo(
					subscription
				);
				const {canSwitchType} = SubscriptionUtil.getSwitchInfo(subscription);
				if (isPurchaseOrder && usedB2BBulkCode && !isTrial) {
					switchButton = (
						<Link
							className={styles.editType}
							to={URLMake.forRedeemSubscription()}
						>
							Extend with new bulk code
						</Link>
					);
				} else if (canUpgrade) {
					switchButton = (
						<div
							className={styles.editType}
							onClick={this.withOwnerCanPayCheck(() =>
								this.goToSubscribeFlow("upgrade")
							)}
						>
							Upgrade {planType === "monthly" ? "Subscription" : "to Bundle"}
						</div>
					);
					if (upgradeUntil) {
						switchWarning = (
							<div className={styles.switchWarning}>
								{`Discounted upgrade available until ${moment(
									upgradeUntil
								).format("MMMM D, YYYY")}`}
							</div>
						);
					}
				} else if (canSwitchType) {
					// Only show if the subscription is past its cancellation period
					// or it's a monthly subscription
					switchButton = (
						<div
							className={styles.editType}
							onClick={this.withOwnerCanSwitchCheck(student, () =>
								this.goToSubscribeFlow("switch")
							)}
						>
							Change Subscription
						</div>
					);
				}
				const planCopy = CopyTable.getAccountPlanCopy();
				const planInfoButton =
					isPurchaseOrder || isTrial ? null : (
						<InfoIcon
							text={planCopy[planType]}
							title={planCopy[planType + "Title"]}
							isModal={true}
							className={styles.info}
						/>
					);
				let subLabelSuffix = "";
				if (usedB2BBulkCode) {
					subLabelSuffix = " (Bulk Code)";
				} else if (isPurchaseOrder) {
					subLabelSuffix = " (Purchase Order)";
				}
				subDetails = (
					<div className={styles.subDetails}>
						<div className={styles.subItem}>
							{planInfoButton}
							<div className={styles.subLabelLarge}>
								{isTrial ? "Affiliate" : effectivePlanType}
								{subLabelSuffix}
							</div>
						</div>
						{switchButton}
						{switchWarning}
						{this.getExpirationEl(student)}
						<div className={styles.spacer} />
						{this.getButton(subscription)}
					</div>
				);
			} else {
				subDetails = (
					<div className={styles.subDetails}>
						<div className={styles.subItem}>
							<div className={styles.subLabelLarge}>
								{this.props.data.inActiveClasses
									? "Included in Class Enrollment"
									: "Inactive"}
							</div>
						</div>
						{this.props.data.latestAcademyClassEndTime
							? this.getExpirationEl(student)
							: null}
						<div className={styles.spacer} />
						{this.getButton(subscription)}
						{isPurchaseOrder && usedB2BBulkCode ? (
							<Link
								className={styles.editType + " " + styles.withTopPadding}
								to={URLMake.forRedeemSubscription()}
							>
								Activate with Bulk Code
							</Link>
						) : null}
					</div>
				);
			}
			return subDetails;
		},

		getDeferralPlacementNote: function(
			deferralPlacementLabel,
			deferralPlacementLoaded,
			hasStudentAccountBeenSetup
		) {
			if (deferralPlacementLabel) {
				return (
					<div className={styles.deferralPlacementNote}>
						{`Your student's placement test placed them in ${deferralPlacementLabel}.`}
					</div>
				);
			}
			if (deferralPlacementLoaded && hasStudentAccountBeenSetup) {
				if (this.state.deferralPlacementTestStatus === "pending") {
					return (
						<div className={styles.deferralPlacementNote}>
							<span
								className={styles.deferralPlacementSpinner}
								aria-hidden="true"
							/>
							{" Signing in as your student & redirecting to the test..."}
						</div>
					);
				}
				return (
					<div className={styles.deferralPlacementNote}>
						{"Your student can take the placement test "}
						<button
							type="button"
							className={styles.deferralPlacementLink}
							onClick={this.onDeferralPlacementTestClick}
						>
							here
						</button>
						{"."}
					</div>
				);
			}
			return null;
		},

		getDeferralSection: function(deferral) {
			if (!deferral) return null;

			const {subscription, usedCode} = this.props.data;
			if (subscription.booksCanceled) return null;

			const {
				deferralGrade,
				deferralStatus,
				deferralPlacementLabel,
				deferralPlacementLoaded,
			} = this.state;
			const expiresAt = moment(deferral.expiresAt).format("MMM D, h:mma");
			const isPending = deferralStatus === "pending";
			const gradeOptions = _.zipObject(
				GRADE_LIST.map(String),
				GRADE_LIST.map(g => `Level ${g}`)
			);

			return (
				<div className={styles.deferralBanner}>
					<div className={styles.deferralHeader}>
						<BookText className={styles.deferralIcon} />
						<span className={styles.deferralHeaderText}>
							{"Confirm your book level by "}
							<strong>{expiresAt}</strong>
						</span>
					</div>
					<div className={styles.deferralControls}>
						<div className={styles.deferralControlsRow}>
							<div className={styles.deferralSelectWrapper}>
								<Dropdown
									className={styles.deferralSelect}
									options={gradeOptions}
									initialValue={String(deferralGrade)}
									updateSelection={this.onDeferralGradeChange}
									arrowType="standard"
									arrowColor="darkGray"
									arrowClass={styles.deferralArrow}
									optionHeight={36}
									smallerPadding={true}
								/>
							</div>
							<LoadableButton
								className={styles.deferralButton}
								buttonText="CONFIRM"
								status={isPending ? "loading" : null}
								onClick={this.onDeferralConfirm}
							/>
						</div>
						{this.getDeferralPlacementNote(
							deferralPlacementLabel,
							deferralPlacementLoaded,
							usedCode
						)}
						{deferralStatus === "error" ? (
							<span className={styles.deferralError}>
								{"Something went wrong. Please try again."}
							</span>
						) : null}
					</div>
				</div>
			);
		},

		getDeferralSuccessModal: function() {
			if (this.state.deferralStatus !== "success") return null;

			const grade = this.state.deferralGrade;
			return (
				<OfficeModal
					onClose={this.closeDeferralSuccessModal}
					closeOnEsc={true}
					portalContainer={null}
					level="overBar"
					modalClass={styles.deferralModal}
					closeClass={styles.deferralModalClose}
					closeHideIcons={true}
				>
					<div className={styles.deferralModalContainer}>
						<div className={styles.deferralModalContent}>
							<div className={styles.deferralModalTitle}>
								{"Order Confirmed"}
							</div>
							<div className={styles.deferralModalBody}>
								{`Your Level ${grade} books should arrive in 2-3 weeks.`}
								<br />
								<br />
								You will receive an email from aops@ses.vesyl.com once your
								order has shipped.
							</div>
						</div>
					</div>
				</OfficeModal>
			);
		},

		render: function() {
			const {className, data, user, students, deferral} = this.props;
			const {
				subscription,
				userID,
				displayName,
				avatar,
				username,
				usedCode,
				lockSettings,
			} = data;
			const {additionalEmailsStatus} = this.state;
			const {active} = subscription;
			const displayNameView = (
				<EditableField
					className={styles.displayName}
					title={"Edit Student Name"}
					fieldType={"displayName"}
					placeholder={"Enter new name"}
					onUpdate={this.updateDisplayName}
					text={displayName}
					textClass={styles.displayNameText}
					maxFieldLength={15}
				/>
			);
			const password = (
				<div className={styles.passwordOuter}>
					<div
						className={styles.password}
						onClick={evt => this.changePassword(displayName, userID)}
					>
						Change Password
					</div>
				</div>
			);
			const giftCodeBtn = (
				<a
					className={styles.giftCode}
					href="/redeemSubscription"
					target="_blank"
					aria-label="Add a subscription code - opens in new tab"
				>
					<Gift style={{width: "14px", height: "14px", marginRight: "4px"}} />{" "}
					Add a subscription code
				</a>
			);

			let modal = null;
			const type = this.state.selectType;
			if (type) {
				const typeCopy = CopyTable.getAccountOptions({
					type,
					styles,
					isParent: true,
				});
				if (type === "updatesSettings") {
					const buttonProps = {
						className: styles.modalButton,
						tabIndex: 70,
					};
					let buttonText;
					let cancel = (
						<div
							className={styles.modalButton}
							onClick={this.closeModals}
							tabIndex={71}
							onKeyPress={this.handleKeyPress}
						>
							{"cancel"}
						</div>
					);

					if (additionalEmailsStatus === "failure") {
						buttonProps.onClick = this.onSaveEmails;
						buttonProps.onKeyPress = evt =>
							this.handleKeyPress(evt, "saveChanges");
						buttonText = "retry";
					} else if (additionalEmailsStatus === "pending") {
						buttonProps.className = styles.modalButtonDisabled;
						buttonText = "pending";
						cancel = null;
					} else {
						buttonProps.onClick = this.onSaveEmails;
						buttonProps.onKeyPress = evt =>
							this.handleKeyPress(evt, "saveChanges");
						buttonText = "save changes";
					}

					const button = <div {...buttonProps}>{buttonText}</div>;

					const additionalEmails = this.state.newAdditionalEmails;
					const addInput = () => {
						const newEmails = _.clone(this.state.newAdditionalEmails);
						newEmails.push({email: "", error: null});
						this.setState({
							newAdditionalEmails: newEmails,
						});
					};
					const addAddressButton =
						this.state.newAdditionalEmails.length >= 5 ? null : (
							<AddElement
								className={styles.addEmailRow}
								onAdd={addInput}
								addText={`Add another email address`}
							/>
						);
					const emails = _.isArray(additionalEmails)
						? _.map(additionalEmails, (emailObj, i) => {
								const emailUpdate = newEmail => {
									let error;
									if (newEmail && !StringUtil.isValidEmail(newEmail)) {
										error = "badEmail";
									}
									if (newEmail && newEmail === user.model.email) {
										error = "sameAsCurrent";
									}
									const newEmails = _.clone(this.state.newAdditionalEmails);
									newEmails[i] = {email: newEmail, error};
									this.setState({newAdditionalEmails: newEmails});
								};
								const deleteEmail = () => {
									const newEmails = _.clone(this.state.newAdditionalEmails);
									newEmails.splice(i, 1);
									this.setState({newAdditionalEmails: newEmails});
								};
								return (
									<div className={styles.emailRow} key={`additionalEmail${i}`}>
										<div className={styles.deleteIconContainer}>
											<DeleteIcon
												className={styles.deleteIcon}
												onDelete={deleteEmail}
											/>
										</div>
										<Input
											className={styles.additionalEmail}
											placeholder={"Enter a valid email address"}
											initialValue={emailObj.email}
											onUpdate={emailUpdate}
											checkType={"email"}
											showErrorType={this.state.newAdditionalEmails[i].error}
											placeholderInside={true}
										/>
									</div>
								);
						  })
						: null;
					const modalErrorMessage = _.some(additionalEmails, obj => obj.error)
						? typeCopy.error
						: null;
					modal = (
						<OfficeModal
							onClose={this.closeModals}
							closeOnEsc={true}
							portalContainer={null}
							level="overBar"
							modalClass={styles.modalMain}
						>
							<div className={styles.container}>
								<div className={styles.modalTitle}>{typeCopy.title}</div>
								<div className={styles.modalDescription}>
									{typeCopy.description}
								</div>
								<div className={styles.modalEmailHeader}>{"YOUR EMAIL:"}</div>
								<div className={styles.modalPrimaryEmail}>
									{user.model.email}
								</div>
								<div className={styles.modalEmailHeader}>
									{"ADDITIONAL EMAILS:"}
								</div>
								<div className={styles.emailsContainer}>{emails}</div>
								{addAddressButton}
								<div className={styles.error}>{modalErrorMessage}</div>
								<div className={styles.modalButtons}>
									{button}
									{cancel}
								</div>
							</div>
						</OfficeModal>
					);
				} else {
					let initiallyChecked = [];
					let initiallySelected = data[type];
					if (type === "lockSettings") {
						initiallyChecked = _.filter(
							_.keys(lockSettings),
							k => lockSettings[k] === true
						);
						initiallySelected = _.get(lockSettings, "scheme", data[type]);
					}
					modal = (
						<SelectModal
							title={typeCopy.title}
							details={typeCopy.description}
							options={typeCopy.options}
							hideDescription={typeCopy.title === "Select BA Level"}
							centerOptions={typeCopy.title === "Select BA Level"}
							initiallyChecked={initiallyChecked}
							initiallySelected={initiallySelected}
							onSelect={selectOptionState =>
								this.selectOption(type, selectOptionState)
							}
							onClose={this.closeModals}
							status={this.state.studentInfoStatus}
						/>
					);
				}
			}

			let basicInfo, settingsB, getRefundEl;
			if (subscription.canceledAt) {
				const canceledAt = moment(subscription.canceledAt).format("LL");
				const refundedAt =
					subscription.refundedAt &&
					moment(subscription.refundedAt).format("LL");
				const usedB2BBulkCode = subscription.usedB2BBulkCode;
				getRefundEl = cn => (
					<div className={cn}>
						{CopyTable.getCancelRefundCopy(
							canceledAt,
							refundedAt,
							usedB2BBulkCode
						)}
					</div>
				);
			} else {
				getRefundEl = () => null;
			}

			// usedCode means the student's account has been set up
			if (usedCode) {
				basicInfo = (
					<div className={styles.userBasic}>
						{displayNameView}
						<div className={styles.username}>{username}</div>
						{password}
						{giftCodeBtn}
						{this.getDeferralSection(deferral)}
						{this.getSettings(data, styles.settingsA)}
						{getRefundEl(styles.refundB)}
					</div>
				);
				settingsB = this.getSettings(data, styles.settingsB);
			} else {
				const setupLink = getStudentRegistrationPage(userID);
				const setup = active ? (
					<Link className={styles.setupButton} to={setupLink}>
						set up account
					</Link>
				) : null;
				basicInfo = (
					<div className={styles.userBasic}>
						{displayNameView}
						<div className={styles.setupMessage}>
							This Student Account has not been set up.
						</div>
						{setup}
						{giftCodeBtn}
						{this.getDeferralSection(deferral)}
						{getRefundEl(styles.refundB)}
					</div>
				);
			}

			if (this.state.cancelOtherSubscriptionOpen) {
				const otherActiveYearlyStudents = students.filter(
					s =>
						s.subscription.active &&
						s.subscription.planType === "yearly" &&
						s.userID !== userID
				);

				modal = (
					<CancelOtherSubscriptionModal
						onClose={this.closeModals}
						otherActiveYearlyStudents={otherActiveYearlyStudents}
					/>
				);
			}

			if (this.state.cancelBundleOpen) {
				modal = (
					<CancelBundleModal
						data={data}
						hasPendingBookDeferral={Boolean(deferral)}
						onClose={this.closeModals}
					/>
				);
			}

			let errorMessage;
			if (this.state.error) {
				errorMessage = CopyTable.getTryAgain();
			}

			const outerClass = active ? styles.basicOuter : styles.inactiveOuter;

			return (
				<div className={className} key={userID}>
					<div className={styles.topRow}>
						<div className={outerClass}>
							<Avatar
								className={styles.avatar}
								avatar={avatar}
								hasRing={true}
								fallbackDisplayName={displayName}
							/>
							{basicInfo}
							{getRefundEl(styles.refundA)}
						</div>
						{this.getSubscriptionDetails(data)}
					</div>
					{settingsB}
					<div className={styles.error}>{errorMessage}</div>
					{modal}
					{this.getDeferralSuccessModal()}
				</div>
			);
		},
	})
);
